export const SUGGEST_MIN_CHARS = 2

export const SEARCH_BY_OPTIONS = [
  { value: "all", label: "All", buttonLabel: "Search by" },
  { value: "candidate", label: "Candidate", buttonLabel: "Candidate" },
  { value: "lead", label: "Leads", buttonLabel: "Leads" },
  { value: "offer", label: "Proposals", buttonLabel: "Proposals" },
  { value: "email", label: "Emails", buttonLabel: "Emails" },
  { value: "sms", label: "SMS", buttonLabel: "SMS" },
  { value: "meeting", label: "Meetings", buttonLabel: "Meetings" },
  { value: "call", label: "Calls", buttonLabel: "Calls" },
  { value: "task", label: "Tasks", buttonLabel: "Tasks" },
  { value: "workflow", label: "Workflows", buttonLabel: "Workflows" },
  { value: "note", label: "Notes", buttonLabel: "Notes" },
]

export const SEARCH_BY_PLACEHOLDERS = {
  all: "Search candidates, proposals, emails, SMS...",
  candidate: "Search candidates...",
  lead: "Search MLS agents and import leads...",
  offer: "Search proposals...",
  email: "Search emails...",
  sms: "Search SMS templates...",
  meeting: "Search meetings...",
  call: "Search calls and outcomes...",
  task: "Search tasks...",
  workflow: "Search workflows...",
  note: "Search notes...",
}

export const SEARCH_TYPE_LABELS = {
  candidate: "Candidate",
  lead: "Lead",
  offer: "Proposal",
  email: "Email",
  sms: "SMS",
  sms_template: "SMS Template",
  meeting: "Meeting",
  call: "Call",
  task: "Task",
  workflow: "Workflow",
  note: "Note",
}

export const SEARCH_TYPE_COLORS = {
  candidate: { bg: "#F6E9FE", fg: "#7728A4" },
  lead: { bg: "#EEF2FF", fg: "#3538CD" },
  offer: { bg: "#FDF2F8", fg: "#C11574" },
  email: { bg: "#EEF4FF", fg: "#3538CD" },
  sms: { bg: "#ECFDF3", fg: "#067647" },
  sms_template: { bg: "#ECFDF3", fg: "#067647" },
  meeting: { bg: "#FFF6ED", fg: "#C4320A" },
  call: { bg: "#F0F9FF", fg: "#026AA2" },
  task: { bg: "#FFFAEB", fg: "#B54708" },
  workflow: { bg: "#F4F3FF", fg: "#5925DC" },
  note: { bg: "#F8FAFC", fg: "#344054" },
}

export const SEARCH_BY_SEE_ALL_LABELS = {
  all: "See all matching results",
  candidate: "See all matching candidates",
  lead: "See all matching leads",
  offer: "See all matching proposals",
  email: "See all matching emails",
  sms: "See all matching SMS templates",
  meeting: "See all matching meetings",
  call: "See all matching calls",
  task: "See all matching tasks",
  workflow: "See all matching workflows",
  note: "See all matching notes",
}

export const RESULT_SECTIONS = {
  candidates: "candidates",
  emailEventTransactions: "emaileventtransaction",
  smsSendEvents: "smssendevent",
  offers: "offer",
  meetings: "scheduledmeeting",
  calls: "call",
  workflows: "workflow",
  notes: "note",
}
